import { createModifiedOnColDef } from '../../../../../components/shared-columns/modified-on/modified-on';
import type { FirmSalesCoverageGridItemFragment } from '../graphql/__generated__';
import { employeeKeyColDef } from './employee-key';
import { employeeNameColDef } from './employee-name';
import { jobFunctionColDef } from './job-function';
import { relationshipStatusColDef } from './relationship-status';
import { relationshipTypeColDef } from './relationship-type';

export const firmsSalesCoverageGridColumns = [
  employeeKeyColDef,
  employeeNameColDef,
  jobFunctionColDef,
  relationshipTypeColDef,
  createModifiedOnColDef<FirmSalesCoverageGridItemFragment>('lastUpdated'),
  relationshipStatusColDef,
];
